import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_front-desk/sarah/staff")({
  beforeLoad: ({ context }) => guardRoute(context.me, "sarah-staff"),
  component: Outlet,
});
